rs.module("ui/controls/contentheader",

    ["controls/navigation/sitemenu"],

    function (siteMenu) {

        // Initialize the header
        function initialize(jsSelectors, cssClasses) {

            var contentHeader = $.js(jsSelectors.contentHeader);
            var menuToggle = contentHeader.js(jsSelectors.menuToggle, { required: false });

            $(window).scroll(function () {

                contentHeader.toggleClass(cssClasses.scrollShadow, $(this).scrollTop() > 0);

            });

            //open the menu when the hamburger button is clicked
            menuToggle.on("click", function () {
                siteMenu.toggleMobileMenu(true);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);